import { SignalingMessageAnswer } from "../../../services";
import { BaseStreamingCommand } from "./BaseStreamingCommand";

export class AnswerCommand extends BaseStreamingCommand {
  public execute(e: unknown): void {
    const event = e as CustomEvent<SignalingMessageAnswer>;
    const answer = event.detail;
    if (!this.checkRoomId(answer.data.room)) return;
    if (!answer.from) return;
    const peer = this.getPeer(answer.from);
    if (!peer) return;
    let description: RTCSessionDescription;
    try {
      description = new RTCSessionDescription({
        sdp: answer.data.sdp,
        type: "answer"
      });
    } catch (error) {
      console.warn("Failed to build answer description", error);
      return;
    }
    peer
      .handleDescription(description, this.getRoomLocalParticipantRemoteId())
      .catch((error: unknown) => {
        console.warn("Failed to apply answer description", error);
      });
  }
}
